// extracted by mini-css-extract-plugin
export default {"detailContainer":"components-workTime-TodaysWorkTimeInfo-__detailContainer","detailEntriesList":"components-workTime-TodaysWorkTimeInfo-__detailEntriesList"};